module.exports = __webpack_public_path__ + "img/sam-tank-pride-02.bc92e5f6.jpg";